export const navLinks = [
  { label: "首页", href: "#top" },
  { label: "热度榜", href: "#ranking" },
  { label: "鉴定案例", href: "#cases" },
  { label: "鉴定方法", href: "#methods" },
  { label: "疑点讨论", href: "#discuss" },
  { label: "辟谣对照", href: "#timeline" },
];

export const heroStats = [
  { value: "12,486", label: "已受理鉴定" },
  { value: "3,902", label: "判定为伪造" },
  { value: "98.2%", label: "复核一致率" },
];

export const heroKeywords = [
  "P图鉴定",
  "真假分析",
  "疑点讨论",
  "辟谣对比",
  "像素分析",
  "光影对比",
];

export const tickerItems = [
  "某综艺后台合影 光源方向不一致 → 判定：双人拼接",
  "活动酒会抓拍 阴影与灯位吻合 → 判定：实锤为真",
  "聊天截图照片 文字图层叠加 → 判定：伪造",
  "剧组路透偷拍 边缘锯齿明显 → 判定：AI 重绘",
  "十年毕业照 压缩伪影与机型相符 → 判定：倾向真实",
  "网红旧照 背景透视错位 → 判定：存疑待补原图",
];

export const hotRanking = [
  {
    rank: 1,
    title: "某综艺后台合影：两侧人物光源方向不一致",
    tag: "P图痕迹",
    heat: "8.9万",
    verdict: "伪造",
    verdictType: "fake",
  },
  {
    rank: 2,
    title: "活动酒会抓拍：阴影落点与现场灯位完全吻合",
    tag: "光影对比",
    heat: "7.4万",
    verdict: "实锤",
    verdictType: "real",
  },
  {
    rank: 3,
    title: "剧组路透偷拍：人物边缘出现规则锯齿",
    tag: "像素分析",
    heat: "6.1万",
    verdict: "伪造",
    verdictType: "fake",
  },
  {
    rank: 4,
    title: "十年前毕业照：压缩伪影与当年机型特征一致",
    tag: "元数据",
    heat: "5.3万",
    verdict: "实锤",
    verdictType: "real",
  },
  {
    rank: 5,
    title: "网红旧照：背景墙透视与人物不共面",
    tag: "疑点讨论",
    heat: "4.2万",
    verdict: "存疑",
    verdictType: "unsure",
  },
];

export const latestFeed = [
  {
    time: "3 分钟前",
    title: "这张酒店大堂照的地砖接缝突然断了，疑似拉伸拼接",
    author: "像素猎人",
    replies: 128,
    tag: "P图痕迹",
  },
  {
    time: "17 分钟前",
    title: "求鉴定：逆光人像的头发边缘有一圈灰边，是抠图吗？",
    author: "吃瓜先看稿",
    replies: 86,
    tag: "疑点讨论",
  },
  {
    time: "41 分钟前",
    title: "已经找到原图出处，属于正常合影，本楼辟谣",
    author: "对照档案员",
    replies: 212,
    tag: "辟谣对比",
  },
  {
    time: "1 小时前",
    title: "放大 400% 后文字边缘有荧光溢出，基本可以定性",
    author: "放大镜研究员",
    replies: 154,
    tag: "像素分析",
  },
  {
    time: "2 小时前",
    title: "同一张图两个版本，噪点分布完全不同，谁在动手？",
    author: "光影校对组",
    replies: 97,
    tag: "光影对比",
  },
];

export const featuredCases = [
  {
    id: "case-shadow-splice",
    size: "large",
    cover:
      "https://readdy.ai/api/search-image?query=Two%20nearly%20identical%20group%20photographs%20placed%20side%20by%20side%20on%20a%20clean%20warm%20beige%20surface%2C%20red%20marker%20annotations%20circling%20inconsistent%20shadow%20directions%2C%20forensic%20comparison%20layout%20with%20grid%20overlay%2C%20soft%20studio%20lighting%2C%20minimal%20editorial%20style%2C%20high%20detail&width=1100&height=760&seq=heiliiao-case-shadow-splice&orientation=landscape",
    tag: "P图痕迹",
    title: "某综艺后台合影：光源方向不一致",
    summary:
      "左侧人物投影朝右、右侧人物投影朝左，同框却来自两个光源。结合边缘融合痕迹，判定为双人拼接。",
    verdict: "伪造",
    verdictType: "fake",
    views: "12.4万",
    discuss: "1,286",
  },
  {
    id: "case-backlight",
    cover:
      "https://readdy.ai/api/search-image?query=Backlit%20portrait%20photograph%20enlarged%20on%20a%20light%20wooden%20table%20with%20a%20grey%20halo%20highlighted%20around%20the%20hair%20edge%20by%20a%20red%20circle%2C%20magnifying%20glass%20beside%20it%2C%20warm%20amber%20lighting%2C%20clean%20analytical%20editorial%20composition%2C%20high%20detail&width=800&height=560&seq=heiliiao-case-backlight&orientation=landscape",
    tag: "疑点讨论",
    title: "逆光人像头发边缘的灰边",
    summary: "发丝外圈出现均匀灰边，是抠图还是传感器高光溢出？两派观点仍在吵。",
    verdict: "存疑",
    verdictType: "unsure",
    views: "6.8万",
    discuss: "742",
  },
  {
    id: "case-metadata",
    cover:
      "https://readdy.ai/api/search-image?query=Close%20up%20of%20a%20computer%20screen%20showing%20image%20metadata%20fields%20and%20histogram%20curves%20for%20an%20old%20photograph%2C%20warm%20dark%20room%20with%20amber%20screen%20glow%2C%20restrained%20forensic%20desk%20setting%2C%20stylized%20analytical%20photography%2C%20high%20detail&width=800&height=560&seq=heiliiao-case-metadata&orientation=landscape",
    tag: "元数据",
    title: "十年前毕业照的压缩伪影",
    summary: "伪影分布与当年主流机型编码特征高度一致，未发现二次编辑区块。",
    verdict: "实锤",
    verdictType: "real",
    views: "5.1万",
    discuss: "507",
  },
  {
    id: "case-chat-screenshot",
    cover:
      "https://readdy.ai/api/search-image?query=A%20chat%20screenshot%20photo%20printed%20on%20paper%20with%20text%20layer%20edges%20marked%20by%20red%20guide%20lines%20on%20a%20warm%20beige%20desk%2C%20pixel%20inspection%20loupe%20next%20to%20it%2C%20soft%20neutral%20lighting%2C%20minimal%20forensic%20editorial%20style%2C%20high%20detail&width=800&height=560&seq=heiliiao-case-chat-screenshot&orientation=landscape",
    tag: "像素分析",
    title: "聊天截图照片：文字图层叠加",
    summary: "文字区域底色与周围存在可见色阶断层，判定为后期贴字。",
    verdict: "伪造",
    verdictType: "fake",
    views: "9.3万",
    discuss: "964",
  },
  {
    id: "case-perspective",
    cover:
      "https://readdy.ai/api/search-image?query=Interior%20photo%20of%20a%20hotel%20lobby%20printed%20on%20matte%20paper%20with%20perspective%20guide%20lines%20drawn%20over%20the%20floor%20tiles%20in%20red%20ink%2C%20warm%20neutral%20desk%2C%20analytic%20comparison%20setup%2C%20soft%20daylight%2C%20clean%20editorial%20composition%2C%20high%20detail&width=800&height=560&seq=heiliiao-case-perspective&orientation=landscape",
    tag: "透视校验",
    title: "酒店大堂照：地砖接缝突然断开",
    summary: "地面透视消失点在中段跳变，人物与背景疑似不共面，等待原始文件。",
    verdict: "存疑",
    verdictType: "unsure",
    views: "4.5万",
    discuss: "388",
  },
  {
    id: "case-lighting",
    cover:
      "https://readdy.ai/api/search-image?query=Event%20banquet%20candid%20photograph%20shown%20on%20a%20tablet%20screen%20with%20light%20source%20direction%20arrows%20drawn%20in%20red%2C%20warm%20amber%20ambient%20light%2C%20dark%20restrained%20forensic%20desk%2C%20stylized%20analytical%20photography%2C%20high%20detail&width=800&height=560&seq=heiliiao-case-lighting&orientation=landscape",
    tag: "光影对比",
    title: "酒会抓拍：阴影落点与现场灯位吻合",
    summary: "手腕阴影角度与吊灯位置计算一致，未见拼接缝隙，判定为真。",
    verdict: "实锤",
    verdictType: "real",
    views: "7.7万",
    discuss: "631",
  },
];

export const methodPoints = [
  {
    icon: "ri-magic-line",
    title: "P图痕迹检测",
    desc: "查边缘融合、克隆复制、局部分辨率突变，定位后期修改区块。",
  },
  {
    icon: "ri-sun-line",
    title: "光影对比",
    desc: "还原光源方向与强度，核对投影、高光和反射是否自洽。",
  },
  {
    icon: "ri-focus-3-line",
    title: "原始像素分析",
    desc: "放大噪点分布、压缩伪影与色阶断层，判断是否经过重编码。",
  },
  {
    icon: "ri-scales-3-line",
    title: "辟谣对照",
    desc: "找到原始出处与同场景多角度图，逐条对照疑点做出结论。",
  },
];

export const rumorFacts = [
  {
    rumor: "「深夜同框照」说明两人关系不一般",
    fact: "原图取自公开活动合影，同框共 7 人，裁剪后被断章取义。",
    tag: "裁剪误导",
  },
  {
    rumor: "「素颜丑照」是本人真实状态",
    fact: "面部区域经过液化与磨皮，下颌线像素出现规律位移。",
    tag: "P图伪造",
  },
  {
    rumor: "「冲突现场照」证明双方当场翻脸",
    fact: "视频完整版显示为正常交流，截图定格在表情夸张的瞬间。",
    tag: "定格误导",
  },
  {
    rumor: "「旧照流出」显示当事人前后变化巨大",
    fact: "所谓旧照实为新人照片套用滤镜，元数据拍摄时间晚于流出时间。",
    tag: "张冠李戴",
  },
];

export const timelineItems = [
  {
    date: "09-10",
    title: "某后台合影开始在群聊流传",
    desc: "首轮扩散，评论区出现「P图」质疑，尚无技术拆解。",
    type: "spread",
  },
  {
    date: "09-11",
    title: "光影方向不一致被指出",
    desc: "有用户用标尺比对投影角度，提出双光源疑点。",
    type: "doubt",
  },
  {
    date: "09-12",
    title: "本站出具技术拆解报告",
    desc: "边缘融合 + 光源矛盾双重证据，判定为拼接伪造。",
    type: "verdict",
  },
  {
    date: "09-12",
    title: "原始出处被找到并对照",
    desc: "确认原图为多人合影，流传版本被裁掉其余人物。",
    type: "clear",
  },
];

export const discussTopics = [
  { name: "P图痕迹", count: 1268 },
  { name: "光影对比", count: 934 },
  { name: "像素分析", count: 872 },
  { name: "辟谣对比", count: 741 },
  { name: "疑点讨论", count: 655 },
  { name: "元数据", count: 512 },
  { name: "透视校验", count: 430 },
  { name: "AI 重绘", count: 388 },
];

export const footerLinks = [
  {
    title: "内容频道",
    items: ["P图鉴定", "真假分析", "疑点讨论", "辟谣对比"],
  },
  {
    title: "鉴定方法",
    items: ["光影对比", "像素分析", "元数据核查", "透视校验"],
  },
  {
    title: "参与方式",
    items: ["提交照片", "申请复核", "成为鉴定员", "举报错误结论"],
  },
];